module.exports = __webpack_public_path__ + "img/change- background.a003df7d.png";